import { ComponentRef, Directive, OnInit, Type, ViewContainerRef, effect, inject, input } from '@angular/core';
import { PxdGridDefaultComponent } from '@app/shared/kendoui/grid/components/pxd-grid-default/pxd-grid-default.component';
import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';

export interface Field {
  columns: PxdColumns[];
  data: any;
  config?: any;
  columnSettingsKey?: string;
  lockSelectionCheckbox?: boolean;
}

const components: { [type: string]: Type<PxdGridDefaultComponent> } = {
  default: PxdGridDefaultComponent
};

@Directive({
  selector: '[dynamicGrid]',
})
export class DynamicGridDirective implements OnInit {
  private container = inject(ViewContainerRef);

  readonly columns = input<PxdColumns[]>(undefined);
  readonly data = input<any>(undefined);
  readonly grid = input<string>(undefined);
  readonly gridConfig = input<any>(undefined);
  readonly columnSettingsKey = input<string>(undefined);
  readonly lockSelectionCheckbox = input<boolean>(undefined);

  public component: ComponentRef<PxdGridDefaultComponent>;

  constructor() {
    effect(() => {
      // Trigger the effect when any of the inputs change
      this.columns();
      this.data();
      this.grid();
      this.gridConfig();
      this.columnSettingsKey();
      this.lockSelectionCheckbox();

      if (this.component) {
        this.setComponentInputs();
      }
    });
  }

  public ngOnInit() {
    this.component = this.container.createComponent(components[this.grid()]);
    this.setComponentInputs();
  }

  private setComponentInputs() {
    this.component.setInput('columns', this.columns());
    this.component.setInput('data', this.data());
    this.component.setInput('config', this.gridConfig());
    this.component.setInput('columnSettingsKey', this.columnSettingsKey());
    this.component.setInput('lockSelectionCheckbox', this.lockSelectionCheckbox());
  }
}